
//Match title height

function MatchHeight() {
  
	// $(".product-item .product-item__inner .product-item__media").matchHeight();
	$(".product-item .product-item__inner .product-item__media .product-item__image-link").matchHeight();
  
}
MatchHeight();

$(window).on("load", function () {  
  MatchHeight();
});